var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonAFY, ContextMenuAFY, IconAFY, icons, sizes, sizesIcon, state, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../../assets/themes/theme";
import { getCustomerAction } from "../../../fnx/customer";
import LocalStorageService from "../../../services/localStorage";
import { DivLongText, DivStatus, } from "../../../apap/salesCore/auditPage/assets/style";
import React from "react";
import { newFormattedDate } from "../../../utils/date";
export var planDto = {
    titlePage: "Plan",
    viewType: "2",
    titleMetaTag: "Affinity Plan",
    informationPage: {
        backgroundColor: themeCore.colors.background,
        colorText: themeCore.colors.secondaryText,
        description: "Seleccion el plan que necesite el cliente",
        icon: icons.Help,
        iconSize: sizesIcon.standard,
        iconColor: themeCore.colors.primary,
    },
    filter: {
        backgroundColor: "#FFFFFF",
        bgChipInsurers: "#fff",
        bgChipInsurersSelected: "#EBEEF6",
        bgColorButton: "#fff",
        bgColorComparativeButton: "#3A56A1",
        bgColorIconButton: "#EBEEF6",
        bgColorIconButtonSelected: "#3A56A1",
        colorIconButton: "#3A56A1",
        colorIconButtonSelected: "#fff",
        colorIconChip: "#3A56A1",
        colorText: "#3A56A1",
        comparativeTextButton: "ver comparativa",
        comparativeTextColor: "#fff",
        insurers: [],
        title: "Patrocinador",
        titleFirstChip: "Todas",
    },
    data: [],
};
export var stepProgress = [
    {
        id: "1",
        name: "Nombre del seguro",
        state: state.complete,
    },
    {
        id: "2",
        name: "Tipo de plan",
        state: state.complete,
    },
    {
        id: "3",
        name: "Datos del cliente",
        state: state.complete,
    },
    {
        id: "4",
        name: "Confirmación",
        state: state.complete,
    },
    {
        id: "5",
        name: "Datos de pago",
        state: state.complete,
    },
    {
        id: "6",
        name: "Confirmación de pago",
        state: state.complete,
    },
];
export var TabAutoColumns = function (f, isQuote) {
    var active = isQuote == "false";
    var columns = [
        {
            field: "type",
            headerName: "Acciones",
            width: 150,
            renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "transparent", iconButton: icons.MoreVert, disableRipple: true, iconColor: "#3A56A1", menuItem: [
                        {
                            disabled: active,
                            icon: {
                                color: "#006ac6",
                                icon: icons.Edit,
                                size: sizesIcon.standard,
                            },
                            id: "1",
                            name: "Actualizar",
                        },
                    ], onClickContextMenu: f, sizeIcon: sizesIcon.smallXl }) }))); },
        },
        {
            field: "brand",
            headerName: "Marca",
            width: 150,
        },
        {
            field: "model",
            headerName: "Modelo",
            width: 150,
        },
        {
            field: "color",
            headerName: "Color",
            width: 150,
        },
        {
            field: "price",
            headerName: "Valor",
            width: 150,
        },
        {
            field: "cylinders",
            headerName: "Numero de cilindros",
            width: 250,
        },
        {
            field: "fueltype",
            headerName: "Tipo de combustible",
            width: 250,
        },
        {
            field: "plate",
            headerName: "Placa",
            width: 150,
        },
    ];
    return columns;
};
export var Tab1Columns = function (showEdit, canEditInsurance, rows) {
    // Verificar si algún registro tiene datos en marriedName
    var hasMarriedName = rows === null || rows === void 0 ? void 0 : rows.some(function (row) { return row.marriedName && row.marriedName.trim() !== ""; });
    var columns = [
        {
            field: "type",
            headerName: "Tipo asegurado",
            width: 180,
        },
        {
            field: "names",
            headerName: "Nombres",
            width: 280,
        },
        {
            field: "lastNames",
            headerName: "Apellidos",
            width: 280,
        },
        {
            field: "phone1",
            headerName: "Teléfono",
            width: 150,
        },
        {
            field: "dob",
            headerName: "Fecha nacimiento",
            width: 220,
        },
    ];
    if (hasMarriedName) {
        columns.splice(3, 0, {
            field: "marriedName",
            headerName: "Apellido de casada",
            width: 240,
        });
    }
    if (canEditInsurance) {
        columns.unshift({
            field: "actions",
            headerName: "Acciones",
            width: 100,
            renderCell: function (params) { return (_jsx(_Fragment, { children: params.row.type !== "Titular" && (_jsx(ButtonAFY, { size: sizes.small, variant: variants.text, label: "Editar", color: themeCore.colors.buttonPrimary, onClick: function () { return showEdit(params); } })) })); },
        });
    }
    return columns;
};
export var Tab2Columns = function (showEdit, canEditBeneficiary) {
    var columns = [
        {
            field: "type",
            headerName: "Tipo beneficiario",
            width: 200,
        },
        {
            field: "names",
            headerName: "Nombres",
            width: 280,
        },
        {
            field: "lastNames",
            headerName: "Apellidos",
            width: 280,
        },
        {
            field: "dob",
            headerName: "Fecha nacimiento",
            width: 230,
        },
        {
            field: "percentage",
            headerName: "Porcentaje",
            width: 170,
        },
    ];
    if (canEditBeneficiary) {
        columns.unshift({
            field: "actions",
            headerName: "Acciones",
            width: 100,
            renderCell: function (params) { return (_jsx(_Fragment, { children: params.row.type !== "Titular" && (_jsx(ButtonAFY, { size: sizes.small, variant: variants.text, label: "Editar", color: themeCore.colors.buttonPrimary, onClick: function () { return showEdit(params); } })) })); },
        });
    }
    return columns;
};
export var Tab3Columns = [
    {
        field: "accountName",
        headerName: "Nombre",
        width: 300,
    },
    {
        field: "accountType",
        headerName: "Tipo ",
        width: 250,
    },
    {
        field: "accountNumber",
        headerName: "Número",
        width: 200,
    },
    {
        field: "paymentMode",
        headerName: "Modo de pago",
        width: 150,
    },
    {
        field: "prime",
        headerName: "Prima",
        width: 150,
    },
];
export function getFilters(filtersDTO, isVidaTermino, tl, data) {
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    var filtersForApapAuto = [
        {
            name: "Producto",
            label: filtersDTO.product,
            type: "label",
        },
        {
            name: "Plan",
            label: filtersDTO.plan,
            type: "label",
            showChangeButton: false,
        },
        {
            name: "Campaña",
            label: filtersDTO.campaing,
            type: "label",
            showChangeButton: false,
        },
        {
            name: "Prima",
            label: filtersDTO.currency + " " + filtersDTO.prime,
            type: "label",
        },
        {
            name: "Año",
            label: filtersDTO.year,
            type: "label",
        },
        {
            name: "Modelo",
            label: filtersDTO.model,
            type: "label",
        },
        {
            name: "Marca",
            label: filtersDTO.brand,
            type: "label",
        },
        {
            name: "Chasis",
            label: filtersDTO.chassis,
            type: "label",
        },
        {
            name: "Placa",
            label: filtersDTO.plate,
            type: "label",
        },
        {
            name: "Estado del Vehiculo",
            label: filtersDTO.statusVehicle,
            type: "label",
        },
    ];
    var filtersForOthers = [
        {
            name: "Tipo de producto",
            label: filtersDTO.projectType,
            type: "label",
        },
        {
            name: "Producto",
            label: filtersDTO.product,
            type: "label",
        },
        {
            name: "Plan",
            label: filtersDTO.plan,
            type: "label",
            showChangeButton: !(filtersDTO.isQuote !== null && filtersDTO.isQuote === "false"),
        },
        {
            name: "Tipo de pago",
            label: filtersDTO.paymentMode,
            type: "label",
        },
        {
            name: "Tipo de cobertura",
            label: filtersDTO.coverType,
            type: "label",
        },
        {
            name: "Campaña",
            label: filtersDTO.campaing,
            type: "label",
        },
        {
            name: "Prima",
            label: "".concat(filtersDTO.currency, " ").concat(filtersDTO.prime),
            type: "label",
        },
    ];
    var filtersForVidaTermino = [
        {
            name: tl("financialInformation.dataFilter.Product"),
            label: filtersDTO.product,
            type: "label",
        },
        {
            name: tl("financialInformation.dataFilter.Birthdate"),
            label: newFormattedDate(filtersDTO.birthdate),
            type: "label",
        },
        {
            name: tl("financialInformation.dataFilter.Gender"),
            label: filtersDTO.gender,
            type: "label",
        },
        // {
        //   name: tl("financialInformation.dataFilter.PolicyDuration"),
        //   label:
        //     localStorageService.getStepStored().steps[Steps.initialInfo].initialInfo
        //       .policyDuration + " años",
        //   type: "label",
        // },
        // {
        //   name: tl("financialInformation.dataFilter.SumInsured"),
        //   label: `RD$ ${filtersDTO.prime}`,
        //   type: "label",
        // },
    ];
    if (isVidaTermino && isVidaTermino === true) {
        return filtersForVidaTermino;
    }
    return getCustomerAction().customerAuto.includes(filtersDTO.subdomain)
        ? filtersForApapAuto
        : filtersForOthers;
}
export var dataEditVehicleForm = {
    carDetails: [
        {
            brand: {
                id: "",
                name: "",
            },
            model: {
                id: "",
                name: "",
            },
            version: {
                id: "",
                name: "",
            },
        },
    ],
    year: "",
    carColor: [
        {
            id: "",
            name: "",
        },
    ],
    chassisNumber: "",
    price: "",
    numberCylinders: [
        {
            id: "",
            name: "",
        },
    ],
    fuelType: [
        {
            id: "",
            name: "",
        },
    ],
    registrationNumber: "",
    carCondition: [
        {
            id: "",
            name: "",
        },
    ],
};
export var StatementColumns = function (tl) {
    var columns = [
        {
            field: "accountName",
            headerName: tl("confirmationData.columnsStatement.accountName"),
            width: 300,
        },
        {
            field: "amount",
            headerName: tl("confirmationData.columnsStatement.amount"),
            width: 150,
        },
        {
            field: "paymentDate",
            headerName: tl("confirmationData.columnsStatement.paymentDate"),
            width: 250,
        },
        {
            field: "dateExpire",
            headerName: tl("confirmationData.columnsStatement.dateExpire"),
            width: 200,
        },
        {
            field: "datePaid",
            headerName: tl("confirmationData.columnsStatement.datePaid"),
            width: 200,
        },
        {
            field: "state",
            headerName: tl("confirmationData.columnsStatement.state"),
            width: 150,
        },
    ];
    return columns;
};
var getStatusColor = function (state) {
    switch (state) {
        case "Listo":
            return "green";
        case "Rechazado":
            return "red";
        case "Pendiente":
            return "yellow";
        case "Sin documento":
            return "blue";
        default:
            return "gray";
    }
};
export var AdditionalDocumentationColumns = function (handleClickContextMenu) {
    var columns = [
        {
            field: "actions",
            headerName: "Acciones",
            width: 150,
            renderCell: function (param) {
                return (_jsx("div", __assign({ style: { display: "flex" } }, { children: _jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                            {
                                disabled: false,
                                icon: {
                                    color: "#006ac6",
                                    icon: icons.UploadFile,
                                    size: sizesIcon.standard,
                                },
                                id: "1",
                                name: "Subir documento",
                            },
                            {
                                disabled: !param.row.documentClientUrl,
                                icon: {
                                    color: "#006ac6",
                                    icon: icons.Visibility,
                                    size: sizesIcon.standard,
                                },
                                id: "2",
                                name: "Visualizar",
                            },
                        ], onClickContextMenu: function (item) { return handleClickContextMenu(item, param); }, sizeIcon: sizesIcon.standard }) })));
            },
        },
        {
            field: "docType",
            width: 450,
            headerName: "Tipo de documento",
            renderCell: function (params) {
                return _jsx(DivLongText, { children: params.value });
            },
        },
        {
            width: 200,
            field: "state",
            headerName: "Estado",
            renderCell: function (params) {
                return (_jsxs(DivStatus, { children: [_jsx(IconAFY, { icon: icons.Circle, color: getStatusColor(params.value) }), " ", params.value] }));
            },
        },
        {
            field: "date",
            headerName: "Fecha",
            width: 200,
        },
        {
            field: "user",
            headerName: "Usuario",
            width: 175,
        },
    ];
    return columns;
};
export var rowsClientDocument = [
    {
        id: "",
        docType: "",
        state: "",
        date: "",
        user: "",
    },
];
export var heightList = [
    {
        id: "1",
        name: "4' 7\"",
        value: "1",
    },
    {
        id: "2",
        name: "4' 8\"",
        value: "2",
    },
    {
        id: "3",
        name: "4' 11\"",
        value: "3",
    },
    {
        id: "4",
        name: "5' 0\"",
        value: "4",
    },
    {
        id: "5",
        name: "5' 1\"",
        value: "5",
    },
    {
        id: "6",
        name: "5' 2\"",
        value: "6",
    },
    {
        id: "7",
        name: "5' 3\"",
        value: "7",
    },
    {
        id: "8",
        name: "5' 4\"",
        value: "8",
    },
    {
        id: "9",
        name: "5' 5\"",
        value: "9",
    },
    {
        id: "10",
        name: "5' 6\"",
        value: "10",
    },
    {
        id: "11",
        name: "5' 7\"",
        value: "11",
    },
    {
        id: "12",
        name: "5' 8\"",
        value: "12",
    },
    {
        id: "13",
        name: "5' 9\"",
        value: "13",
    },
    {
        id: "14",
        name: "5' 10\"",
        value: "14",
    },
    {
        id: "15",
        name: "5' 11\"",
        value: "15",
    },
    {
        id: "16",
        name: "6' 0\"",
        value: "16",
    },
    {
        id: "17",
        name: "6' 1\"",
        value: "17",
    },
    {
        id: "18",
        name: "6' 2\"",
        value: "18",
    },
    {
        id: "19",
        name: "6' 3\"",
        value: "19",
    },
    {
        id: "20",
        name: "6' 4\"",
        value: "20",
    },
    {
        id: "21",
        name: "6' 5\"",
        value: "21",
    },
    {
        id: "22",
        name: "6' 6\"",
        value: "22",
    },
    {
        id: "23",
        name: "6' 7\"",
        value: "23",
    },
    {
        id: "24",
        name: "6' 8\"",
        value: "24",
    },
    {
        id: "25",
        name: "6' 9\"",
        value: "25",
    },
    {
        id: "26",
        name: "6' 10\"",
        value: "26",
    },
    {
        id: "27",
        name: "6' 11\"",
        value: "27",
    },
];
export var maritalStatusList = [
    { id: "1", name: "Soltero", value: "1" },
    { id: "2", name: "Casado", value: "2" },
    { id: "4", name: "Unión Libre", value: "4" },
];
export var Tab4Columns = [
    {
        editable: true,
        field: "name",
        flex: 1,
        headerName: "Nombre",
        width: 150,
    },
    {
        editable: true,
        field: "lastName",
        flex: 1,
        headerName: "Apellidos",
        width: 150,
    },
    {
        editable: true,
        field: "idType",
        flex: 1,
        headerName: "Tipo Identificación",
        width: 150,
    },
    {
        editable: true,
        field: "documentNumber",
        flex: 1,
        headerName: "No. Documento",
        width: 150,
    },
    {
        editable: true,
        field: "birthDate",
        flex: 1,
        headerName: "Fecha Nacimiento",
        width: 200,
    },
    {
        editable: false,
        field: "age",
        flex: 1,
        headerName: "Edad",
        width: 80,
    },
    {
        editable: true,
        field: "gender",
        flex: 1,
        headerName: "Sexo",
        width: 100,
    },
    {
        editable: true,
        field: "passport",
        flex: 1,
        headerName: "Pasaporte",
        width: 150,
    },
    {
        editable: true,
        field: "phone",
        flex: 1,
        headerName: "Teléfono",
        width: 150,
    },
    {
        editable: true,
        field: "email",
        flex: 1,
        headerName: "Correo Electronico",
        width: 200,
    },
];
export var TabRealEstateColumns = [
    {
        field: "ownerName",
        flex: 1,
        headerName: "Razón Social",
        width: 150,
    },
    {
        field: "businessShift",
        flex: 1,
        headerName: "Giro o actividad del negocio",
        width: 150,
    },
    {
        field: "typeConstruction",
        flex: 1,
        headerName: "Tipo de construcción",
        width: 150,
    },
    {
        field: "propertyTypeId",
        flex: 1,
        headerName: "Tipo de sector de negocio",
        width: 150,
    },
];
export var TabRealEstateHomeColumns = [
    {
        field: "typeConstruction",
        flex: 1,
        headerName: "Tipo de construcción",
        width: 150,
    },
    {
        field: "propertyAddress",
        flex: 1,
        headerName: "Dirección de la propiedad",
        width: 150,
    },
];
